<template>
  <vue-draggable-resizable
    class="draggableItem _widgetEdit"
    drag-cancel=".dragCancel"
    :x='300'
    :y='10'
     :w="1400"
     :h="900"



    >
    <div class="draggableItem__header">
      <span class="draggableItem__title">Widget template</span>
      <a
        href="#"
        class="draggableItem__close dragCancel"
        @click.prevent="close(widget['.key'])"
        v-b-tooltip.hover
        title="close"
        >
        <icon name="remove" />
      </a>
    </div>
    <div class="draggableItem__body">
      <b-form
        class="widget-edit__form"
        @submit.prevent="save"
        >
        <div class="widget-edit__content">
          <div class="row">
            <div class="col-sm-6">
              <b-form-group label="Card title:">
                <b-form-input
                  v-model="title"
                  type="text"
                  @keydown.ctrl.83.native.prevent="save"
                  class="dragCancel"
                />
              </b-form-group>
            </div>
            <div class="col-sm-6">
              <b-form-group label="Card Classes:">
                <b-form-input
                  v-model="classes"
                  type="text"
                  @keydown.ctrl.83.native.prevent="save"
                  class="dragCancel"
                />
              </b-form-group>
            </div>
          </div>
          <!-- <div>
            <div>
              <b-form-group label="Layout:">
                <b-form-checkbox
                  v-model="autoHeight"
                >
                  Auto height
                </b-form-checkbox>
              </b-form-group>
            </div>
          </div> -->
          <div v-if="widget.type !== 'card-list'">
            <b-form-group label="Layout:">
              <b-form-select
                v-model="layout"
                :options="layouts"
                class="dragCancel"
              />
            </b-form-group>
          </div>
          <div v-if="widget.type === 'card-list'">
            <b-form-group label="Layout:">
              <b-form-select
                v-model="layout"
                :options="layouts"
                class="dragCancel"
              />
            </b-form-group>

            <b-form-group label="Data Source:">
              <b-form-select
                v-model.trim="$v.dataSource.$model"
                class="dragCancel"
                :class="{ 'is-invalid': $v.dataSource.$error }"
                :disabled="inProgress"
              >
                <optgroup
                  v-for="modelType in dataSourceList"
                  :key="modelType.text"
                  :label="modelType.text"
                >
                  <option
                    v-for="model in modelType.value"
                    :key="model.text"
                    :value="model.value"
                  >
                    {{ model.text }}
                  </option>
                </optgroup>
              </b-form-select>
              <b-form-invalid-feedback
                v-if="!$v.dataSource.required"
              >
                Data Source is required
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
          <div>
            <b-form-group label="Editor type:">
              <b-form-radio-group
                v-model="selectedEditorView"
                :options="editorViews"
                buttons
                button-variant="outline-primary"
                size="sm"
              />
            </b-form-group>
          </div>
          <div v-if="widget.type === 'card-list'">
            <b-form-group label="Template type:">
              <b-form-radio-group
                v-model="selectedTemplateType"
                :options="templateTypes"
                buttons
                button-variant="outline-primary"
                size="sm"
              />
            </b-form-group>
          </div>

          <div
            v-if="widget.type === 'card-list' && selectedTemplateType === 'list'"
            class="widget-edit__editor"
          >
            <div
              v-if="selectedEditorView === 'codemirror'"
              class="widget-edit__codeMirror"
            >
              <div>
                <label>Template:</label>
                <codemirror
                  :value="templateCode"
                  :options="cmTemplateOptions"
                  @keydown.ctrl.83.native.prevent="save"
                  @input="onCmTemplateCodeChange"
                  class="dragCancel"
                />
              </div>
              <div>
                <label>Styles:</label>
                <codemirror
                  :value="stylesCode"
                  :options="cmStylesOptions"
                  @keydown.ctrl.83.native.prevent="save"
                  @input="onCmStylesCodeChange"
                  class="dragCancel"
                />
              </div>
            </div>
          </div>

          <div
            v-if="widget.type === 'card-list' && selectedTemplateType === 'detail'"
            class="widget-edit__editor"
          >
            <div
              v-if="selectedEditorView === 'codemirror'"
              class="widget-edit__codeMirror"
            >
              <div>
                <label>Detail Template:</label>
                <codemirror
                  :value="detailCode"
                  :options="cmTemplateOptions"
                  @keydown.ctrl.83.native.prevent="save"
                  @input="onCmDetailCodeChange"
                  class="dragCancel"
                />
              </div>
              <div>
                <label>Styles:</label>
                <codemirror
                  :value="stylesCode"
                  :options="cmStylesOptions"
                  @keydown.ctrl.83.native.prevent="save"
                  @input="onCmDetailStylesCodeChange"
                  class="dragCancel"
                />
              </div>
            </div>
          </div>

          <div
            v-if="widget.type !== 'card-list'"
            class="widget-edit__editor"
          >
            <div
              v-if="selectedEditorView === 'codemirror'"
              class="widget-edit__codeMirror"
            >
              <div>
                <label>Template:</label>
                <codemirror
                  :value="templateCode"
                  :options="cmTemplateOptions"
                  @keydown.ctrl.83.native.prevent="save"
                  @input="onCmTemplateCodeChange"
                  class="dragCancel"
                />
              </div>
              <div>
                <label>Styles:</label>
                <codemirror
                  :value="stylesCode"
                  :options="cmStylesOptions"
                  @keydown.ctrl.83.native.prevent="save"
                  @input="onCmStylesCodeChange"
                  class="dragCancel"
                />
              </div>
            </div>


            <div style="display:flex"
              v-else-if="selectedEditorView === 'editor'"
              class="widget-edit__editor"
            >
              <div style="width:50%">
                <h2>Template</h2>
                <div class='templateWrapper'
                  v-html="editorCode"
                  @click="handleClick"
                  >
                >
                </div>
                <div class='addToolbar text-center'>
                  <b-button
                    variant=""
                    size="sm"
                    @click="addRow"
                  >add row</b-button>
                </div>
              </div>

              <div style="margin-left:50px">
                <h2>Editor - <span v-if="this.editorElement">{{this.editorElement.tagName}}</span></h2>
                <div>

                  <label v-show="elText">Text:</label>
                  <b-form-textarea
                      v-show="elText"
                      id="textarea"
                      v-model="elText"
                      placeholder=""
                      rows="3"
                      max-rows="6"
                      @input="textChange"
                    ></b-form-textarea>

                  <label >Classes:</label>
                  <div style='height:190px'>
                    <treeselect
                      style="width:400px"
                      @input='updateEl'
                        v-model="editorClasses"
                        :multiple=true
                        :options="dynamicOptions"
                        :always-open=true
                        :searchable=true
                        :clearable=true
                        :defaultExpandLevel=2
                        :flat=true
                        :maxHeight=150
                      />
                  </div>
                  <label
                  v-show="this.editorElement">Add Component:</label>
                  <treeselect
                  v-show="this.editorElement"
                  style="width:400px"
                  @input='addElement'
                    v-model="addTreeValue"
                    :multiple=false
                    :options="addOptions"
                    :always-open=false
                    :searchable=true
                    :clearable=true
                    :defaultExpandLevel=2
                    :clear-on-select=true

                    :maxHeight=200
                  />
                  <b-button
                  v-show="this.editorElement"
                  class="m-1 float-right"
                    size="sm"
                    variant="success"
                    @click="copyElement"

                  >
                    Copy
                  </b-button>

                  <b-button
                  v-show="this.editorElement  && this.elToCopy"
                  class="m-1 float-right"
                    size="sm"
                    variant="success"
                    @click="pasteElement"

                  >
                    Paste
                  </b-button>

                  <b-button
                  v-show="this.editorElement"
                  class="m-1 float-right"
                    size="sm"
                    variant="warning"
                    @click="removeElement"

                  >
                    Remove
                  </b-button>



                </div>

              </div>
            </div>





          </div>

          <div>
            <b-button
              variant="primary"
              size="sm"
              type="submit"
              class="dragCancel"
              >
              Save
            </b-button>
          </div>
        </div>
      </b-form>
    </div>
  </vue-draggable-resizable>
</template>

<script>
import { mapState } from 'vuex'
// services
import db from '@/services/db'
// helpers
import eventBus from '@/helpers/event-bus'
import constants from '@/helpers/constants'

let $ = window.$

export default {
  props: ['widget'],
  data: function () {
    return {
      addOptions: [
        {
        id: 'Select',
        label: 'Select'
        },
        {
        id: 'grid',
        label: 'Grid',
        children: [ {
          id: 'row',
          label: 'Row',
        }, {
          id: 'col',
          label: 'Column',
        }
        ]},
         {
        id: 'content',
        label: 'Content',
        children: [
           {
          id: 'button',
          label: 'button',
        },
          {
          id: 'h1',
          label: 'h1',
        }, {
          id: 'h2',
          label: 'h2',
        }, {
          id: 'h3',
          label: 'h3',
        }, {
          id: 'p',
          label: 'p',
        }
        ]}


        ],


      options: [ {
        id: 'layout',
        label: 'Layout',
        children: [ {
          id: 'p-1',
          label: 'Padding 1',
        }, {
          id: 'm-1',
          label: 'Margin 1',
        } ,
        {
          id: 'float-right',
          label: 'Float Right',
        }, {
          id: 'float-left',
          label: 'Float Left',
        }],
       },
       {id: 'gridColumns',
        label: 'Grid Columns',
        children: [
            {
          id: 'row',
          label: 'Row Container',
          },
            {
            id: 'col-2',
            label: '2 Column',
          }, {
            id: 'col-4',
            label: '4 Column',
          },
            {
            id: 'col-6',
            label: '6 Column',
          },
            {
            id: 'col-8',
            label: '8 Column',
          },
            {
            id: 'col-10',
            label: '10 Column',
          }],
            }
            ,{
              id: 'button',
              label: 'Button',
              children: [
              {
                id: 'btn',
                label: 'Button',
              }, {
                id: 'btn-primary',
                label: 'Primary',
              },
                {
                id: 'btn-secondary',
                label: 'Secondary',
              },
                {
                id: 'btn-alert',
                label: 'Alert',
              },
              {
                id: 'btn-warning',
                label: 'Warning',
              }],
            }],

      title: this.widget.title,
      templateCode: this.widget.template || '',
      detailCode: this.widget.detailTemplate || '',
      stylesCode: this.widget.styles || '',
      detailStylesCode: this.widget.detailStyles || '',
      gjsComponents: this.widget.gjsComponents || '',
      gjsDetailComponents: this.widget.gjsDetailComponents || '',
      classes: this.widget.classes,
      layout: this.widget.layout,
      dataSource: this.widget.dataSource,
      layouts: [
        { text: 'B-Card', value: 'b-card' },
        { text: 'Standard', value: null }
      ],
      autoHeight: this.widget.autoHeight,
      cmTemplateOptions: constants.cmTemplateOptions,
      cmStylesOptions: constants.cmStylesOptions,
      width: 0,
      height: 0,
      x: 0,
      y: 0,
      inProgress: false,
      widgetsComputed: null,
      editorViews: [
        { text: 'CodeMirror', value: 'codemirror' },
        { text: 'Editor', value: 'editor' }
      ],
      selectedEditorView: 'editor',
      templateTypes: [
        { text: 'List Editor', value: 'list' },
        { text: 'Detail Editor', value: 'detail' }
      ],
      selectedTemplateType: 'list',
      editorClasses:[],
      editorElement:null,
      editorCode: this.widget.template || '',
      addTreeValue:'Select',
      elText:'',
      elToCopy:null
    }
  },
  computed: {
    ...mapState([
      'dataGrid_options'
    ]),
    dynamicOptions (){
      var nOptions = []
      nOptions = this.options
      if(!this.editorElement) return nOptions

      if(this.editorElement.tagName == 'DIV')
      {
        nOptions = []
        nOptions.push(this.options[1])
      }

      if('H1 H2 H3 P'.includes(this.editorElement.tagName))
      {
        nOptions = []
        nOptions.push(this.options[0])
      }

      if(this.editorElement.tagName == 'BUTTON')
      {
        nOptions = []
        nOptions.push(this.options[0])
        nOptions.push(this.options[2])
      }




      return nOptions
    },
    grid () {
      let grid = []
      for (let idx of this.widgets) {
        grid.push(idx)
      }
      return grid
    },
    dataSourceList () {
      const list = []
      const computed = []
      const dataGrids = []

      for (let key in this.widgetsComputed) {
        computed.push({ text: key, value: key })
      }

      for (let key in this.dataGrid_options) {
        const options = this.dataGrid_options[key]
        let model

        model = this.widget.type === 'card-list' ? options.source : `$getDataGridVals($getGrid('${options.source}'))`

        dataGrids.push({ text: options.title, value: model })
      }

      list.push({ text: 'Computed Properties', value: computed })
      list.push({ text: 'Data Grids', value: dataGrids })

      return list
    }
  },
  methods: {
    close (key) {
      this.$store.commit('editWidget', {
        key,
        insert: false
      })
    },
    onCmTemplateCodeChange (code) {
      this.templateCode = code
    },
    onCmStylesCodeChange (code) {
      this.stylesCode = code
    },
    onCmDetailCodeChange (code) {
      this.detailCode = code
    },
    onCmDetailStylesCodeChange (code) {
      this.detailStylesCode = code
    },
    onGJSDetailCodeChange (htmlCode, cssCode, gjsComponents) {
      this.detailCode = htmlCode
      this.detailStylesCode = cssCode
      this.gjsDetailComponents = gjsComponents
    },
    save () {
      if (this.inProgress) return
      this.$v.$touch()
      if (this.$v.$invalid) return
      this.inProgress = true

      let widget = Object.assign({}, this.widget)
      let key = widget['.key']
      delete widget['.key']
      widget.title = this.title || ''
      widget.template = this.templateCode || ''
      widget.detailTemplate = this.detailCode || ''
      widget.styles = this.stylesCode || ''
      widget.detailStyles = this.detailStylesCode || ''
      widget.gjsComponents = this.gjsComponents || null
      widget.gjsDetailComponents = this.gjsDetailComponents || null
      widget.classes = this.classes || ''
      widget.layout = this.layout || ''
      widget.autoHeight = this.autoHeight || null
      widget.dataSource = this.dataSource || null

      this.$store.commit('addProcess', {
        process: 'updateWidget',
        message: 'Updating'
      })

      db.widgets.update(key, widget, (err) => {
        this.$store.commit('deleteProcess', 'updateWidget')
        if (err) this.$store.commit('addError', err.message)

        this.inProgress = false
        this.$nextTick(() => {
          this.$v.$reset()
        })

        eventBus.$emit('widgetTemplateUpdated', this.$store.state.currentTab)
      })
    },
    selectElement(){
      var prevElement = null;
      document.querySelector('.templateWrapper').addEventListener('mousemove',
      function(e){
          var elem = e.target || e.srcElement;
          if (prevElement!= null) {prevElement.removeAttribute('mouseOn');}
          elem.setAttribute('mouseOn', true)
          prevElement = elem;
      },true);
      //be sure to remove mouse on if mouse is off
      $(".templateWrapper *").on({

        mouseleave: function() {
            $(this).removeAttr("mouseOn")
        }

      })



    },
    updateEl(value){
        console.log('el is ')
        console.log(value)
        console.log(this.editorElement)
        var cList = value.join(' ')
        //cList.replace('mouseOn', '')
        this.editorElement.setAttribute("class", cList);
        this.updateTemplate()

    },
    updateTemplate(){
        var templateHTML = $('.templateWrapper').html()
        templateHTML = templateHTML.replace('editselected="true"','')
        templateHTML = templateHTML.replace('mouseon="true"','')
        //console.log(templateHTML)
        this.templateCode = templateHTML

    },
    handleClick(e) {
        //remove selected class from other tags
        $('.templateWrapper * ').removeAttr('editSelected');
        //add it just to this tag
        $(e.target).attr('editSelected', true)
        var classArray = []
        classArray = e.target.classList.value.split(' ')
        this.editorElement = e.target
        this.editorClasses = (e.target.classList.value !== '') ? classArray : null

        var textTags = ' H1 H2 H3 P BUTTON'
        if (textTags.includes(this.editorElement.tagName)) {
          this.elText = $(e.target).text()
        }
        else{
          this.elText = null
        }

    },
    textChange(){
      // set the text of the element to what was typed
      $(this.editorElement).text(this.elText.trim())
      this.updateTemplate()
    },
    removeElement(el){
      // set the text of the element to what was typed
      $(this.editorElement).remove()
      this.updateTemplate()
    },
    copyElement(el){
      // set the text of the element to what was typed
      this.elToCopy = $(this.editorElement).prop('outerHTML')

    },
    pasteElement(){
      // set the text of the element to what was typed
      if (this.editorElement) $(this.editorElement).append(this.elToCopy );
      this.updateTemplate()

    },

    addRow(){
      var newRow = `<div class="row" >
        <div class="col-6">


        </div>
          <div class="col-6">


        </div>
      </div>`
      $('.templateWrapper').append(newRow);
      this.updateTemplate()
    },
    addElement(value, instanceId){
      //if (this.addTreeValue == 'Select') return
      console.log(this.addTreeValue)
      console.log(value)
      console.log(instanceId)
      var comps = {row:`<div class="row" >
        <div class="col-6">
        </div>
          <div class="col-6">
        </div>
        </div>`,
        col:`
          <div class="col-6">
          </div>
            `,
          h1:`
          <h1>text</h1>
            `,
             h2:`
          <h2>text</h2>
            `,
             h3:`
          <h3>text</h3>
            ` ,
             p:`
          <p>text</p>
            `,
             button:`
          <button class='btn btn-primary'>button name</button>
            `
        }

      if (this.editorElement) $(this.editorElement).append(comps[value]);
      this.updateTemplate()
      this.addTreeValue = 'Select'
    }
  },
  mounted(){
    this.selectElement()
  },
  created () {

    let dashboardInst = this

    while (!$(dashboardInst.$el).hasClass('dashboard-component')) {
      dashboardInst = dashboardInst.$parent
    }

    this.widgetsComputed = dashboardInst.widgetsComputedReady
  },
  validations: {
    dataSource: {
      required () {
        if (this.widget.type === 'card-list' && !this.dataSource) return false
        return true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~$scss/globals';

.widget-edit {
  &__form {
    height: 100%;
  }
  &__content {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  &__editor {
    flex: 1;
  }
  .CodeMirror {
   height: 500px;
  }
  &__card-list-editor-wrapper {
    @include cf;
  }
  &__codeMirror {
    height: 500px;
    display: flex;
    padding-bottom: 50px;
    max-height: inherit;
    > div {
      width: 50%;
      > div {
        border: 1px solid $borderColor1;
      }
    }
  }

  &__card-body {
    padding: {
      left: 15px;
      right: 15px;
      top: 10px;
      bottom: 30px;
    }
    &._list {
      padding-bottom: 0;
    }
  }
}
.draggableItem._widgetEdit {


}



</style>

<style >
.templateWrapper * {
  outline: .3px dotted #dddddd;
  min-height: 10px;
}

.templateWrapper .row {
  padding: 5px;

}



[mouseOn]{
  background-color: #bcd5eb !important;
  outline: 2px solid #5166bb !important;
}

[editSelected]{

  outline: 2px solid #2dce89 !important;
}

</style>
